import Isotope from "isotope-layout";

var qsRegex = "";
var isoSettings = {
  layoutMode: "vertical",
  hiddenStyle: {
    opacity: 0,
  },
  visibleStyle: {
    opacity: 1,
  },
  filter: function () {
    return qsRegex ? $(this).text().match(qsRegex) : true;
  },
};

function filters() {
  var cityList = document.querySelector(".cities");
  var artistList = document.querySelector(".artists");

  if (cityList) {
    var cityIso = new Isotope(cityList, isoSettings);
  }
  if (artistList) {
    var artistIso = new Isotope(artistList, isoSettings);
  }

  // use value of search field to filter
  var cityQuickSearch = $(".cities-quicksearch").on(
    "keyup",
    debounce(function () {
      qsRegex = new RegExp(cityQuickSearch.val(), "gi");
      cityIso.arrange();
    }, 200)
  );
  var artistQuickSearch = $(".artists-quicksearch").on(
    "keyup",
    debounce(function () {
      qsRegex = new RegExp(artistQuickSearch.val(), "gi");
      artistIso.arrange();
    }, 200)
  );

  $(".toggle-filter").on("click", function () {
    $(this).parent().toggleClass("z-50");
    $(this).find("svg").toggleClass("transform rotate-180");
    $(this).parent().find(".filter-dropdown").toggle();
  });

  $(".close-filter, .filter-overlay").on("click", function () {
    $(".filter-dropdown").hide();
    $(this).parent().parent().removeClass("z-50");
    $(".toggle-filter svg").removeClass("transform rotate-180");
  });

  $(".filter-dropdown").each(function () {
    $(this).removeClass("opacity-0 pointer-events-none").addClass("hidden");
  });
}

function debounce(fn, threshold) {
  var timeout;
  threshold = threshold || 100;
  return function debounced() {
    clearTimeout(timeout);
    var args = arguments;
    var _this = this;
    function delayed() {
      fn.apply(_this, args);
    }
    timeout = setTimeout(delayed, threshold);
  };
}

export default filters;
